import { GRAPHQL_TERRITORY_QUERIES, GRAPHQL_TERRITORY_MUTATIONS } from 'graphql/territory'
import type {
  TTerritoryMutationsData,
  TTerritoryMutationsName,
  TTerritoryMutationsVariables,
  TTerritoryQueriesData,
  TTerritoryQueriesName,
  TTerritoryQueriesVariables,
} from 'graphql/territory/types'
import { buildLazyQueryHook, buildMutationHook, buildQueryHook } from 'lib/apollo-client/builders'

export const useTerritoryQueries = buildQueryHook<
  TTerritoryQueriesName,
  TTerritoryQueriesVariables,
  TTerritoryQueriesData
>(GRAPHQL_TERRITORY_QUERIES)

export const useTerritoryLazyQueries = buildLazyQueryHook<
  TTerritoryQueriesName,
  TTerritoryQueriesVariables,
  TTerritoryQueriesData
>(GRAPHQL_TERRITORY_QUERIES)

export const useTerritoryMutations = buildMutationHook<
  TTerritoryMutationsName,
  TTerritoryMutationsVariables,
  TTerritoryMutationsData
>(GRAPHQL_TERRITORY_MUTATIONS)
